import { render, staticRenderFns } from "./CommitteeManagementPage.vue?vue&type=template&id=370aa36c&scoped=true"
import script from "./CommitteeManagementPage.vue?vue&type=script&lang=js"
export * from "./CommitteeManagementPage.vue?vue&type=script&lang=js"
import style0 from "./CommitteeManagementPage.vue?vue&type=style&index=0&id=370aa36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370aa36c",
  null
  
)

export default component.exports